export enum AssetTypeLockStatusEnum {
  Unlocked = "UNLOCKED",
  New = "NEW",
  Manual = "MANUALLY_LOCKED",
  Insufficient_Data = "INSUFFICIENT_DATA"
}
